import { FunctionalComponent, h } from '@stencil/core';

import { tw } from './tw';

interface actionItems {
  select: (key: string) => void;
}

interface icoTabItem {
  key: string;
  label: string;
}

type icoTabItems = icoTabItem[];

interface icoTabGroupProps {
  actions: actionItems;
  selectedKey: string;
  tabs: icoTabItems;
  dataTestId: string;
}

const IcoSimpleTabGroup: FunctionalComponent<icoTabGroupProps> = (props) => {
  const { actions, selectedKey, tabs, dataTestId } = props;

  return (
    <div class="flex flex-col m-auto">
      <div
        data-testId={`${dataTestId}-simple-tabs`}
        class="justify-start items-center grid grid-flow-col border-b border-l-0 border-r-0 border-t-0 border-solid border-ico-neutral-3">
        {tabs.map((item) => {
          const isSelected = item.key === selectedKey;

          return (
            <div
              data-testId={`${dataTestId}-simple-tabs-${item.key}`}
              class={tw(
                isSelected
                  ? 'border-clrs-tabs-line-selected-default text-clrs-tabs-text-selected-default border-b-4 font-weight-font-tabs-selected'
                  : 'border-transparent text-clrs-tabs-text-non-selected-default font-weight-font-tabs-unselected hover:bg-ico-neutral-3',
                'font-ico-heading text-sm',
                'cursor-pointer',
                'p-2 m-0 md:mr-10',
                'border-solid border-b-4 border-r-0 border-t-0 border-l-0'
              )}
              onClick={() => actions.select(item.key)}>
              {item.label}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export { IcoSimpleTabGroup };
export default IcoSimpleTabGroup;
